import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const UpdateBannerSliceSlice = createSlice({
  name: 'UpdateBannerSlice',
  initialState,
  reducers: {
    UpdateBannerSlice_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    UpdateBannerSlice_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    UpdateBannerSlice_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_UpdateBannerSlice_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {UpdateBannerSlice_request, UpdateBannerSlice_success, UpdateBannerSlice_failure, Clear_UpdateBannerSlice_Check } = UpdateBannerSliceSlice.actions

export default UpdateBannerSliceSlice.reducer